export default {
    name: 'personalityCounseling',
    path: '/personality-counseling',
    meta: {},
    component: () => import('@/views/personalityCounseling/Home'),
    children: [
        {
            // 学业画像
            name: 'AcademicPortrait',
            path: 'academic-portrait',
            meta: {
                title: '学业画像',
            },
            component: () => import('@/views/personalityCounseling/AcademicPortrait'),
            children: [],
        },
        {
            // 学业画像-练习回顾
            name: 'RecentPractice',
            path: 'recent-practice',
            meta: {
                title: '近期练习',
            },
            component: () => import('@/views/personalityCounseling/RecentPractice'),
            children: [],
        },
    ],
};
